import { render, staticRenderFns } from "@/modules/Property/templates/properties-list.html?vue&type=template&id=77e82c64&scoped=true&"
import script from "@/modules/Property/scripts/properties-list.ts?vue&type=script&lang=js&"
export * from "@/modules/Property/scripts/properties-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Property/styles/properties-list.scss?vue&type=style&index=0&id=77e82c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e82c64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
